<template>
  <div class="text-center">
    <nav class="d-nav d-sm-none-nav">
      <div class="row justify-content-between">
        <div class="my-auto tag-cont col text-left">
          <span
            v-for="(n, index) in list"
            :key="index"
            class="n-item pb-2 pointer"
            @click="scrollToPosition('#' + n.viewId, '#' + n.navId)"
            :id="n.navId"
          >{{n.name}}</span>
        </div>

        <div class="col-4 text-right pr-5">
          <button class="n-btn" @click="scrollToPosition('#action', '')">T A K E &nbsp; A C T I O N</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {};
  },
  methods: {
    scrollToPosition(viewId, navId) {
      $("html, body").animate(
        {
          scrollTop: $(viewId).offset().top - 50
        },
        0
      );
      $(".n-item").removeClass("n-active");
      if (navId) {
        $(navId).addClass("n-active");
      }
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
.d-nav {
  width: 58%;
  height: 80px;
  background-color: white;
  position: fixed;
  margin-left: -27.5%;
  top: 2%;
  left: 50%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -moz-box-shadow: 5px 5px 9px 1px #a7a7a7;
  -webkit-box-shadow: 5px 5px 9px 1px #a7a7a7;
  box-shadow: 5px 5px 9px 1px #a7a7a7;
}

@media screen and (max-width: 920px) {
  .d-sm-none-nav {
    display: none;
  }
}

.n-item {
  font-size: 0.65rem;
  font-weight: 600;
}

@media screen and (min-width: 1281px) {
  .n-item {
    margin: 0 1.3rem;
  }
}
@media screen and (min-width: 1050px) and (max-width: 1280px) {
  .n-item {
    margin: 0 1rem;
  }
}
@media screen and (max-width: 1049px) {
  .n-item {
    margin: 0 0.7rem;
  }
  .d-nav {
    height: 70px !important;
  }
}

@media screen and (min-width: 1140px) {
  .n-item,
  .n-btn {
    font-size: 0.65rem !important;
  }
}
@media screen and (max-width: 1139px) {
  .n-item {
    font-size: 0.65rem !important;
  }
}

@media screen and (min-width: 1050px) and (max-width: 1139px) {
  .n-btn {
    font-size: 0.7rem !important;
  }
}

@media screen and (max-width: 1049px) {
  .n-btn {
    font-size: 0.6rem !important;
  }
}

@media screen and (min-width: 970px) and (max-width: 1049px) {
  .n-btn {
    padding: 0.7rem 1rem !important;
  }
}

@media screen and (max-width: 969px) {
  .n-btn {
    padding: 0.7rem !important;
  }
}

@media screen and (min-width: 970px) {
  .tag-cont {
    padding-left: 3rem;
  }
}
@media screen and (max-width: 969px) {
  .tag-cont {
    padding-left: 1rem;
  }
}

.n-active {
  border-bottom: 3px solid #ffc001;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue